import React from 'react';
import ContentSurface from '../ContentSurface';
import './style.css';

export const GroupRowSkeleton = () => (
  <ContentSurface
    className="community-group-row skeleton-group-row"
    aria-hidden="true"
  >
    <div className="community-group-info">
      <span className="skeleton-block skeleton-group-avatar" />
      <div className="skeleton-group-text">
        <span className="skeleton-block skeleton-group-title" />
        <span className="skeleton-block skeleton-group-meta" />
      </div>
    </div>
    <span className="skeleton-block skeleton-group-btn" />
  </ContentSurface>
);

export const MemberProfileSkeleton = () => (
  <div className="member-profile-skeleton" aria-hidden="true">
    <div className="member-profile-skeleton-header">
      <span className="skeleton-block member-profile-skeleton-avatar" />
      <span className="skeleton-block member-profile-skeleton-name" />
      <span className="skeleton-block member-profile-skeleton-location" />
    </div>
    <div className="member-profile-skeleton-body">
      <span className="skeleton-block member-profile-skeleton-line" />
      <span className="skeleton-block member-profile-skeleton-line member-profile-skeleton-line--short" />
    </div>
  </div>
);

export const GroupPostSkeleton = () => (
  <ContentSurface className="group-post group-post--regular" aria-hidden="true">
    <div className="skeleton-post-header">
      <span className="skeleton-block skeleton-post-avatar" />
      <div className="skeleton-post-author">
        <span className="skeleton-block skeleton-post-name" />
        <span className="skeleton-block skeleton-post-time" />
      </div>
    </div>
    <span className="skeleton-block skeleton-post-image" />
    <span className="skeleton-block skeleton-post-line skeleton-post-line--full" />
    <span className="skeleton-block skeleton-post-line skeleton-post-line--wide" />
    <span className="skeleton-block skeleton-post-line skeleton-post-line--narrow" />
    <div className="skeleton-post-btns">
      <span className="skeleton-block skeleton-post-btn" />
      <span className="skeleton-block skeleton-post-btn" />
    </div>
  </ContentSurface>
);
